// CARISSIMA — Build Your Own picker
// Vanilla JS state machine. No build step required.

(function () {
  'use strict';

  // i18n: pull localized labels injected by the section (window.CARISSIMA_I18N.byo); fall back to EN.
  var T = function (k, fb) { try { return (window.CARISSIMA_I18N && CARISSIMA_I18N.byo && CARISSIMA_I18N.byo[k]) || fb; } catch (e) { return fb; } };

  // ---------- Data ----------
  const catalogueEl = document.getElementById('carissima-byo-catalogue');
  if (!catalogueEl) { console.warn('[BYO] no catalogue blob found'); return; }
  const CAT = JSON.parse(catalogueEl.textContent);

  // Finished-sofa preview catalogue — only the unambiguous bundles (see section liquid).
  const finishedEl = document.getElementById('carissima-byo-finished');
  let FIN_LIST = [];
  try { FIN_LIST = finishedEl ? JSON.parse(finishedEl.textContent) : []; }
  catch (_) { FIN_LIST = []; }
  // Index bundles by fingerprint. Only fingerprints owned by EXACTLY ONE bundle
  // are matchable; ambiguous ones (orientation/sequence twins) resolve to >1 and
  // are deliberately skipped so we never show the wrong sofa.
  const FIN_BY_FP = {};
  FIN_LIST.forEach(function (b) { (FIN_BY_FP[b.fp] = FIN_BY_FP[b.fp] || []).push(b); });

  // ---------- Vocabulary ----------
  const COL3 = { carbon: 'CRB', mossa: 'MOS', caramel: 'CML', smoke: 'SMK', lichin: 'LCN' };
  const COL_LABEL = { carbon: 'Carbon', mossa: 'Mossa', caramel: 'Caramel', smoke: 'Smoke', lichin: 'Lichin' };
  const COL_SWATCH = { carbon: '#66696C', mossa: '#D6D5D1', caramel: '#786952', smoke: '#C5C5C5', lichin: '#495843' };
  const FABRIC_COLOURS = {
    chenille:    ['carbon', 'mossa', 'caramel'],
    performance: ['smoke',  'lichin']
  };
  const DSN3 = { embrace: 'EMB', channel: 'CHL', momento: 'MMT' };
  const FAB3 = { chenille: 'CHN', performance: 'PRF' };

  // Step 6 — "Smart features" add-ons. Prices in cents (Shopify convention).
  // Each has a real Shopify variant (single-variant "Smart feature" products,
  // published to the Online Store, inventory untracked) so its `id` flows into
  // the /cart/add.js payload and the customer is actually charged + fulfilled.
  const FEATURES = {
    wireless: { label: T('feat_wireless','Wireless phone charger'), price: 7000, id: 67698786533690 },
    straight: { label: T('feat_straight','Straight reading light'), price: 6000, id: 67698786566458 },
    flex:     { label: T('feat_flex','Flexible reading light'), price: 5000, id: 67698786599226 },
    drink:    { label: T('feat_drink','Drink holder'),         price: 3000, id: 67698786631994 }
  };
  const MATERIAL_LABEL = (fabric, colour) =>
    (fabric === 'chenille' ? 'Chenille' : 'Performance') + ' — ' + COL_LABEL[colour];

  // `match` strings MUST exactly equal variant.option1 (Module) values in the live catalogue.
  // Verified via MCP query of Reverie Modules (gid 10295256547642) + Essential Modules (gid 10295256580410).
  const REV_MODULES = [
    { code: 'ARMCH', label: T('mod_armch','Armless Chair Storage'),    match: 'Armless Chair Storage' },
    { code: 'CORN',  label: T('mod_corn_rev','Reversible Corner'),        match: 'Reversible Corner' },
    { code: 'LVSTO', label: T('mod_lvsto','Armless Loveseat Storage'), match: 'Armless Loveseat Storage' },
    { code: 'LVSLP', label: T('mod_lvslp','Armless Loveseat Sleeper'), match: 'Armless Loveseat Sleeper' },
    { code: 'CHSTO', label: T('mod_chsto','Reversible Chaise Storage'), match: 'Reversible Chaise Storage' },
    { code: 'LHFCC', label: T('mod_lhfcc','LHF Corner Chaise Storage'), match: 'LHF Corner Chaise Storage' },
    { code: 'RHFCC', label: T('mod_rhfcc','RHF Corner Chaise Storage'), match: 'RHF Corner Chaise Storage' }
  ];
  const ESS_MODULES = [
    { code: 'ARMCH', label: T('mod_armch','Armless Chair Storage'),    match: 'Armless Chair Storage' },
    { code: 'CORN',  label: T('mod_corn','Corner'),                   match: 'Corner' },
    { code: 'LVSTO', label: T('mod_lvsto','Armless Loveseat Storage'), match: 'Armless Loveseat Storage' },
    { code: 'LVSLP', label: T('mod_lvslp','Armless Loveseat Sleeper'), match: 'Armless Loveseat Sleeper' },
    { code: 'CHSTO', label: T('mod_chsto','Reversible Chaise Storage'), match: 'Reversible Chaise Storage' }
  ];

  // ---------- State ----------
  const STATE_KEY = 'carissima.byo-state';
  const initialState = {
    fabric: null,
    colour: null,
    sides: null,
    design: null,
    brand: null,
    modules: {},    // { ARMCH: qty, CORN: qty, ... }
    ottomans: {},   // { lush: qty, quadrate: qty, matryoshka: qty } — multi-type, multi-qty
    features: {},   // { wireless: qty, straight: qty, flex: qty, drink: qty } — Step-6 add-ons
    step: 1
  };
  let state = loadState();

  function loadState() {
    try {
      const raw = JSON.parse(sessionStorage.getItem(STATE_KEY) || '{}');
      // Migrate legacy single-string `ottoman` → new `ottomans` map.
      if (raw.ottoman && !raw.ottomans) raw.ottomans = { [raw.ottoman]: 1 };
      delete raw.ottoman;
      return Object.assign({}, initialState, raw);
    } catch (_) { return Object.assign({}, initialState); }
  }
  function saveState() { sessionStorage.setItem(STATE_KEY, JSON.stringify(state)); }
  function resetDownstream(fromStep) {
    if (fromStep <= 1) { state.colour = null; }
    if (fromStep <= 2) { state.sides = null; state.design = null; }
    if (fromStep <= 3) { state.brand = null; state.modules = {}; }
    if (fromStep <= 4) { state.ottomans = {}; }
  }

  // ---------- Variant lookup ----------
  function findVariant(list, predicate) { return list.find(predicate) || null; }

  function lookupArmrest(side) {
    if (!state.fabric || !state.colour || !state.design) return null;
    const sku = `CAR-ARM-${DSN3[state.design]}-${side}-${FAB3[state.fabric]}-${COL3[state.colour]}`;
    return findVariant(CAT.armrest.variants, v => v.sku === sku);
  }

  function lookupModuleVariant(brand, moduleCode) {
    if (!state.fabric || !state.colour) return null;
    const fam = brand === 'reverie' ? 'REV' : 'ESS';
    const sku = `CAR-${fam}-${moduleCode}-${FAB3[state.fabric]}-${COL3[state.colour]}`;
    const list = (brand === 'reverie' ? CAT.reverie : CAT.essential).variants;
    return findVariant(list, v => v.sku === sku);
  }

  function lookupOttoman(designKey) {
    if (!state.fabric || !state.colour) return null;
    const dsn = { lush: 'LUSH', quadrate: 'QUAD', matryoshka: 'MTRY' }[designKey];
    const sku = `CAR-OTT-${dsn}-${FAB3[state.fabric]}-${COL3[state.colour]}`;
    return findVariant(CAT.ottoman.variants, v => v.sku === sku);
  }

  // ---------- Step rendering ----------
  const root = document.querySelector('[data-byo]');
  const stepEls = root.querySelectorAll('.byo__step');
  function stepEl(n) { return root.querySelector(`.byo__step[data-step="${n}"]`); }

  function setStepUnlocked(n, unlocked) {
    stepEl(n).classList.toggle('is-locked', !unlocked);
  }

  function renderActiveStep() {
    // Highlight selected tiles based on state (querying by data-attr — order-independent)
    setRadio(root.querySelectorAll('[data-brand]'),  'data-brand',  state.brand);
    setRadio(root.querySelectorAll('[data-sides]'),  'data-sides',  state.sides);
    setRadio(root.querySelectorAll('[data-design]'), 'data-design', state.design);
    // Plain fabric tiles (legacy) — exclude combined fabric+colour cards
    setRadio(root.querySelectorAll('[data-fabric]:not([data-colour])'), 'data-fabric', state.fabric);
    // Combined fabric+colour image-cards — selected only when BOTH match
    root.querySelectorAll('[data-fabric][data-colour]').forEach(b => {
      const matches = b.dataset.fabric === state.fabric && b.dataset.colour === state.colour;
      b.classList.toggle('is-selected', matches);
      b.setAttribute('aria-checked', matches ? 'true' : 'false');
    });

    // Bi-directional brand × fabric restriction:
    //   - Brand=Essential → Performance fabric tiles disabled (now multiple cards)
    //   - Fabric=Performance → Essential brand tile disabled
    const essBtn  = root.querySelector('[data-brand="essential"]');
    const perfBtns = root.querySelectorAll('[data-fabric="performance"]');
    const essDisabled  = state.fabric === 'performance';
    const perfDisabled = state.brand  === 'essential';
    if (essBtn) {
      essBtn.toggleAttribute('disabled', essDisabled);
      essBtn.title  = essDisabled  ? 'Essential is only available in Chenille' : '';
    }
    perfBtns.forEach(b => {
      b.toggleAttribute('disabled', perfDisabled);
      b.title = perfDisabled ? 'Performance fabric is only available with Reverie' : '';
    });

    // Colour swatches — only rendered if the legacy swatch host is present.
    // (The image-card flow merges fabric + colour, so the host won't exist there.)
    const swatchHost = root.querySelector('[data-swatches]');
    if (swatchHost) {
      swatchHost.innerHTML = '';
      if (state.fabric) {
        FABRIC_COLOURS[state.fabric].forEach(c => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'byo__swatch';
          btn.setAttribute('role', 'radio');
          btn.setAttribute('data-colour', c);
          btn.setAttribute('aria-checked', state.colour === c ? 'true' : 'false');
          btn.title = COL_LABEL[c];
          btn.innerHTML = `<span class="byo__swatch-chip" style="background:${COL_SWATCH[c]}"></span><span class="byo__swatch-label">${COL_LABEL[c]}</span>`;
          if (state.colour === c) btn.classList.add('is-selected');
          swatchHost.appendChild(btn);
        });
      }
    }

    // Step 4 — render modules
    const modHost = stepEl(4).querySelector('[data-modules]');
    modHost.innerHTML = '';
    if (state.brand && state.fabric && state.colour) {
      const list = state.brand === 'reverie' ? REV_MODULES : ESS_MODULES;
      const variants = (state.brand === 'reverie' ? CAT.reverie : CAT.essential).variants;
      list.forEach(mod => {
        const v = variants.find(x => x.module === mod.match && x.material === MATERIAL_LABEL(state.fabric, state.colour));
        const qty = state.modules[mod.code] || 0;
        // Image set per card:
        //   - If the module has multiple theme-asset renders (essentialModuleImages[code]
        //     length > 1), use those as a fade-crossfade slideshow — same images shown
        //     for every colour, since they're brand-accurate but not colour-specific.
        //   - Otherwise prefer the variant's own product image (colour-accurate); fall
        //     back to the single per-module render so colours without their own image
        //     never show blank.
        const brandImageMap = state.brand === 'essential' ? CAT.essentialModuleImages
                            : state.brand === 'reverie'   ? CAT.reverieModuleImages
                            : null;
        const fallbackImgs = (brandImageMap && brandImageMap[mod.code]) || [];
        const imageList = (fallbackImgs.length > 1)
          ? fallbackImgs
          : ((v && v.image) ? [v.image] : fallbackImgs);
        const slideshow = imageList.length > 1;
        const imgsHtml = imageList.length
          ? imageList.map(u => `<img class="byo__mod-img" src="${u}" alt="${mod.label}">`).join('')
          : `<img class="byo__mod-img" alt="${mod.label}">`;
        const card = document.createElement('div');
        card.className = 'byo__mod';
        if (!v) card.classList.add('is-unavailable');
        card.innerHTML = `
          <div class="byo__mod-imgwrap${slideshow ? ' byo__mod-imgwrap--slideshow byo__mod-imgwrap--slideshow-' + imageList.length : ''}">${imgsHtml}</div>
          <div class="byo__mod-body">
            <div class="byo__mod-name">${mod.label}</div>
            <div class="byo__mod-sub">${mod.code}${v ? '' : ' — unavailable'}</div>
            <div class="byo__mod-price">${v ? formatMoney(v.price) : '—'}</div>
            <div class="byo__qty">
              <button type="button" class="byo__qty-btn" data-qty-dec data-mod-code="${mod.code}" ${qty === 0 ? 'disabled' : ''}>−</button>
              <input class="byo__qty-input" type="text" inputmode="numeric" value="${qty}" readonly aria-label="${mod.label} quantity">
              <button type="button" class="byo__qty-btn" data-qty-inc data-mod-code="${mod.code}" ${v ? '' : 'disabled'}>+</button>
            </div>
          </div>`;
        modHost.appendChild(card);
      });
    }

    // Step 5 — render ottoman cards (multi-type, multi-qty; no T('no_ottoman','No ottoman') tile,
    // since "none" is just every qty=0).
    const ottHost = stepEl(5).querySelector('[data-ottomans]');
    ottHost.innerHTML = '';
    const designs = [
      { key: 'lush',       label: 'Lush',       fabrics: ['chenille'] },
      { key: 'quadrate',   label: 'Quadrate',   fabrics: ['chenille', 'performance'] },
      { key: 'matryoshka', label: 'Matryoshka', fabrics: ['chenille'] }
    ];
    designs.forEach(d => {
      if (!state.fabric || !d.fabrics.includes(state.fabric)) return;
      const v = lookupOttoman(d.key);
      if (!v) return;
      const qty = (state.ottomans && state.ottomans[d.key]) || 0;
      const slideshowImgs = (CAT.ottomanImages && CAT.ottomanImages[d.key]) || [];
      const imageList = slideshowImgs.length > 1 ? slideshowImgs : [v.image];
      const slideshow = imageList.length > 1;
      const imgsHtml = imageList.map(u => `<img class="byo__tile-img" src="${u}" alt="${d.label}">`).join('');
      const card = document.createElement('div');
      card.className = 'byo__ott' + (qty > 0 ? ' is-selected' : '');
      card.dataset.ottCode = d.key;
      card.innerHTML = `
        <span class="byo__tile-imgwrap${slideshow ? ' byo__tile-imgwrap--slideshow byo__tile-imgwrap--slideshow-' + imageList.length : ''}">${imgsHtml}</span>
        <div class="byo__ott-label">${d.label}</div>
        <div class="byo__ott-price">${formatMoney(v.price)}</div>
        <div class="byo__qty">
          <button type="button" class="byo__qty-btn" data-ott-qty-dec data-ott-code="${d.key}" ${qty === 0 ? 'disabled' : ''}>−</button>
          <input class="byo__qty-input" type="text" inputmode="numeric" value="${qty}" readonly aria-label="${d.label} quantity">
          <button type="button" class="byo__qty-btn" data-ott-qty-inc data-ott-code="${d.key}">+</button>
        </div>`;
      ottHost.appendChild(card);
    });

    // Step unlock cascade (new order: 1=brand, 2=armrest, 3=fabric+colour, 4=modules, 5=ottoman)
    setStepUnlocked(2, !!state.brand);
    setStepUnlocked(3, !!(state.brand && state.sides && state.design));
    setStepUnlocked(4, !!(state.brand && state.sides && state.design && state.fabric && state.colour));
    setStepUnlocked(5, !!(state.brand && state.sides && state.design && state.fabric && state.colour));

    renderCart();
    updateFinishedSofa();
    updateModulesNav();
    updateFeaturesUI();
  }

  // Sync the static Step-6 "smart features" cards (qty input + minus-button
  // disabled state + selected ring) with state.features.
  function updateFeaturesUI() {
    Object.keys(FEATURES).forEach(key => {
      const card = root.querySelector(`[data-feature-key="${key}"]`);
      if (!card) return;
      const qty = (state.features && state.features[key]) || 0;
      const input = card.querySelector('.byo__qty-input');
      const dec   = card.querySelector('[data-feat-qty-dec]');
      if (input) input.value = qty;
      if (dec)   dec.disabled = qty === 0;
      card.classList.toggle('is-selected', qty > 0);
    });
  }

  function setRadio(buttons, attr, value) {
    buttons.forEach(b => {
      const matches = b.getAttribute(attr) === value;
      b.classList.toggle('is-selected', matches);
      b.setAttribute('aria-checked', matches ? 'true' : 'false');
    });
  }

  function hasAnyComponent() {
    return !!(state.sides && state.design && state.colour) && (
      Object.values(state.modules).some(q => q > 0) || state.sides
    );
  }

  // ---------- Step 4 modules horizontal scroller + arrows ----------
  function scrollModules(dir) {
    const sc = root.querySelector('[data-modules]');
    if (!sc) return;
    // One click = one card. Measure the rendered card so this stays correct
    // as the responsive width changes; fall back to the 3-up calc if needed.
    const firstCard = sc.querySelector('.byo__mod');
    const gap = parseFloat(getComputedStyle(sc).columnGap || getComputedStyle(sc).gap) || 16;
    const cardW = firstCard ? firstCard.getBoundingClientRect().width : (sc.clientWidth - 2 * gap) / 3;
    // Direct snap to the next card. `scrollBy({behavior:'smooth'})`,
    // CSS `scroll-behavior:smooth`, requestAnimationFrame, and setInterval
    // are all unreliable in some managed Chrome contexts (Claude-in-Chrome
    // preview, etc.) — writing scrollLeft synchronously always works.
    // Inline scroll-behavior:auto bypasses any CSS smooth that would
    // swallow the write. The browser clamps to [0, scrollWidth-clientWidth].
    const oldBehavior = sc.style.scrollBehavior;
    sc.style.scrollBehavior = 'auto';
    sc.scrollLeft = sc.scrollLeft + dir * (cardW + gap);
    sc.style.scrollBehavior = oldBehavior;
    updateModulesNav();                         // sync the arrow disabled state
  }
  function updateModulesNav() {
    const sc  = root.querySelector('[data-modules]');
    const nav = root.querySelector('[data-modules-nav]');
    if (!sc || !nav) return;
    const max = sc.scrollWidth - sc.clientWidth;
    nav.hidden = max <= 2;                       // only show arrows when the row overflows
    const prev = nav.querySelector('[data-modules-prev]');
    const next = nav.querySelector('[data-modules-next]');
    if (prev) prev.disabled = sc.scrollLeft <= 1;
    if (next) next.disabled = sc.scrollLeft >= max - 1;
  }

  // ---------- Event handlers (delegated from root — survives DOM changes) ----------
  root.addEventListener('click', (e) => {
    const t = e.target;
    // walk up to the nearest button-like element with one of our data hooks

    // Combined fabric + colour image-card — sets BOTH at once.
    // Must come before the plain [data-fabric] handler.
    const comboFabEl = t.closest && t.closest('[data-fabric][data-colour]');
    if (comboFabEl && root.contains(comboFabEl) && !comboFabEl.hasAttribute('disabled')) {
      onFabricColour(comboFabEl.dataset.fabric, comboFabEl.dataset.colour);
      return;
    }

    const fabricEl  = t.closest && t.closest('[data-fabric]');
    if (fabricEl && root.contains(fabricEl))  { onFabric(fabricEl.dataset.fabric);   return; }
    const sidesEl   = t.closest && t.closest('[data-sides]');
    if (sidesEl  && root.contains(sidesEl))   { onSides(sidesEl.dataset.sides);     return; }
    const designEl  = t.closest && t.closest('[data-design]');
    if (designEl && root.contains(designEl))  { onDesign(designEl.dataset.design);  return; }
    const colourEl  = t.closest && t.closest('[data-colour]');
    if (colourEl && root.contains(colourEl))  { onColour(colourEl.dataset.colour);  return; }
    const brandEl   = t.closest && t.closest('[data-brand]');
    if (brandEl  && root.contains(brandEl) && !brandEl.hasAttribute('disabled')) {
      onBrand(brandEl.dataset.brand); return;
    }
    const ottIncEl  = t.closest && t.closest('[data-ott-qty-inc]');
    if (ottIncEl && root.contains(ottIncEl)) { onOttQty(ottIncEl.dataset.ottCode, +1); return; }
    const ottDecEl  = t.closest && t.closest('[data-ott-qty-dec]');
    if (ottDecEl && root.contains(ottDecEl) && !ottDecEl.hasAttribute('disabled')) {
      onOttQty(ottDecEl.dataset.ottCode, -1); return;
    }
    const featIncEl = t.closest && t.closest('[data-feat-qty-inc]');
    if (featIncEl && root.contains(featIncEl)) { onFeatQty(featIncEl.dataset.featKey, +1); return; }
    const featDecEl = t.closest && t.closest('[data-feat-qty-dec]');
    if (featDecEl && root.contains(featDecEl) && !featDecEl.hasAttribute('disabled')) {
      onFeatQty(featDecEl.dataset.featKey, -1); return;
    }
    const incEl     = t.closest && t.closest('[data-qty-inc]');
    if (incEl    && root.contains(incEl)) { onQty(incEl.dataset.modCode, +1); return; }
    const decEl     = t.closest && t.closest('[data-qty-dec]');
    if (decEl    && root.contains(decEl) && !decEl.hasAttribute('disabled')) {
      onQty(decEl.dataset.modCode, -1); return;
    }
    const addEl     = t.closest && t.closest('[data-add]');
    if (addEl    && root.contains(addEl) && !addEl.hasAttribute('disabled')) { addToCart(); return; }
    const mPrevEl   = t.closest && t.closest('[data-modules-prev]');
    if (mPrevEl  && root.contains(mPrevEl) && !mPrevEl.hasAttribute('disabled')) { scrollModules(-1); return; }
    const mNextEl   = t.closest && t.closest('[data-modules-next]');
    if (mNextEl  && root.contains(mNextEl) && !mNextEl.hasAttribute('disabled')) { scrollModules(1);  return; }
  });

  // ----- Field handlers (simple toggle; cascade-clear runs in afterChange) -----
  function onFabric(f) { state.fabric  = (state.fabric  === f) ? null : f; afterChange(); }
  // Combined: click a fabric image-card → set fabric + colour together (toggle if same).
  function onFabricColour(f, c) {
    const same = state.fabric === f && state.colour === c;
    state.fabric = same ? null : f;
    state.colour = same ? null : c;
    afterChange();
  }
  function onSides(s)  { state.sides   = (state.sides   === s) ? null : s; afterChange(); }
  function onDesign(d) { state.design  = (state.design  === d) ? null : d; afterChange(); }
  function onColour(c) { state.colour  = (state.colour  === c) ? null : c; afterChange(); }
  function onBrand(b)  { state.brand   = (state.brand   === b) ? null : b; afterChange(); }
  function onQty(code, delta) {
    const next = Math.max(0, (state.modules[code] || 0) + delta);
    if (next === 0) delete state.modules[code]; else state.modules[code] = next;
    afterChange();
  }
  function onOttQty(key, delta) {
    const next = Math.max(0, ((state.ottomans && state.ottomans[key]) || 0) + delta);
    if (!state.ottomans) state.ottomans = {};
    if (next === 0) delete state.ottomans[key]; else state.ottomans[key] = next;
    afterChange();
  }
  function onFeatQty(key, delta) {
    if (!FEATURES[key]) return;
    const next = Math.max(0, ((state.features && state.features[key]) || 0) + delta);
    if (!state.features) state.features = {};
    if (next === 0) delete state.features[key]; else state.features[key] = next;
    afterChange();
  }

  // ----- Cascade: any field belonging to a re-locked step gets cleared -----
  // New step order: 1=brand · 2=sides+design · 3=fabric+colour · 4=modules · 5=ottoman
  function cascadeClear() {
    // Bi-directional conflict: Essential is Chenille-only. If both are picked, drop fabric
    // (less disruptive — brand was picked first in the new flow).
    if (state.brand === 'essential' && state.fabric === 'performance') {
      state.fabric = null;
    }
    // Step 2 (sides + design) requires Step 1 brand
    if (!state.brand) {
      state.sides  = null;
      state.design = null;
    }
    // Step 3 (fabric) requires Step 2 complete
    if (!state.sides || !state.design) {
      state.fabric = null;
    }
    // Colour lives in Step 3 alongside fabric; colour palette depends on fabric
    if (!state.fabric) {
      state.colour = null;
    }
    // Step 4 (modules) requires Step 3 complete + brand
    if (!state.brand || !state.fabric || !state.colour) {
      state.modules = {};
    }
    // Step 5 (ottoman) requires Step 3 complete (ottoman is brand-independent)
    if (!state.fabric || !state.colour) {
      state.ottomans = {};
    } else {
      // Drop any ottoman whose design no longer matches the current fabric
      // (e.g. Lush/Matryoshka aren't available in Performance).
      const allowed = {
        lush:       ['chenille'],
        quadrate:   ['chenille', 'performance'],
        matryoshka: ['chenille']
      };
      Object.keys(state.ottomans || {}).forEach(k => {
        if (!allowed[k] || !allowed[k].includes(state.fabric)) delete state.ottomans[k];
      });
    }
  }

  function afterChange() { cascadeClear(); saveState(); renderActiveStep(); }

  // ---------- Cart preview ----------
  function buildCartItems() {
    const items = [];
    // Armrests
    if (state.sides === 'lhf' || state.sides === 'both') {
      const v = lookupArmrest('LHF'); if (v) items.push({ id: v.id, qty: 1, label: `${capitalize(state.design)} armrest — Left`, price: v.price });
    }
    if (state.sides === 'rhf' || state.sides === 'both') {
      const v = lookupArmrest('RHF'); if (v) items.push({ id: v.id, qty: 1, label: `${capitalize(state.design)} armrest — Right`, price: v.price });
    }
    // Modules
    if (state.brand) {
      const list = state.brand === 'reverie' ? REV_MODULES : ESS_MODULES;
      list.forEach(mod => {
        const qty = state.modules[mod.code] || 0;
        if (qty < 1) return;
        const v = lookupModuleVariant(state.brand, mod.code);
        if (v) items.push({ id: v.id, qty, label: `${mod.label} × ${qty}`, price: v.price * qty });
      });
    }
    // Ottomans (multi-type, multi-qty)
    Object.entries(state.ottomans || {}).forEach(([key, qty]) => {
      if (qty < 1) return;
      const v = lookupOttoman(key);
      if (!v) return;
      const suffix = qty > 1 ? ` × ${qty}` : '';
      items.push({ id: v.id, qty, label: `${capitalize(key)} ${T('ottoman_word','ottoman')}${suffix}`, price: v.price * qty });
    });
    return items.concat(featureItems());
  }

  // Smart features (Step 6 add-ons). Each carries its Shopify variant `id`, so it is
  // included in the /cart/add.js payload (see addToCart) and billed. Sold on top of
  // BOTH a per-component build and a matched pre-assembled bundle.
  function featureItems() {
    const items = [];
    Object.entries(state.features || {}).forEach(([key, qty]) => {
      if (qty < 1 || !FEATURES[key]) return;
      const f = FEATURES[key];
      const suffix = qty > 1 ? ` × ${qty}` : '';
      items.push({ id: f.id, qty, label: `${f.label}${suffix}`, price: f.price * qty });
    });
    return items;
  }

  // Returns { matched, items }. On an exact bundle match we sell the single bundle variant
  // (its components ship automatically); otherwise we sell per-component. Smart-feature
  // add-ons are appended on either path so they're always charged.
  function buildCart() {
    const m = matchBundleVariant();
    if (m) {
      const items = [{ id: m.variant.id, qty: 1, label: m.bundle.title + ' (complete set)', price: m.variant.price }];
      return { matched: m.bundle, items: items.concat(featureItems()) };
    }
    return { matched: null, items: buildCartItems() };
  }

  function renderCart() {
    const items = buildCart().items;
    const linesEl = root.querySelector('[data-cart-lines]');
    const totalEl = root.querySelector('[data-cart-total]');
    const btn     = root.querySelector('[data-add]');
    linesEl.innerHTML = items.length === 0
      ? '<li class="byo__cart-empty">Make your selections to see your cart.</li>'
      : items.map(it =>
          `<li><span>${it.label}</span><span>${formatMoney(it.price)}</span></li>`
        ).join('');
    const total = items.reduce((s, it) => s + it.price, 0);
    totalEl.textContent = formatMoney(total);
    btn.disabled = items.length === 0;
  }

  // ---------- Bundle match (drives BOTH the finished-sofa preview and the cart swap) ----------
  // Resolves the current build to a pre-assembled bundle ONLY when it unambiguously maps to
  // exactly one bundle that is purchasable in the chosen design + material. Returns
  // { bundle, variant } or null. Ambiguous builds (orientation/sequence twins) never resolve,
  // so we never show OR sell the wrong sofa.
  function matchBundleVariant() {
    if (!state.brand || !state.sides || !state.design || !state.fabric || !state.colour) return null;
    // Fingerprint MUST equal the custom.byo_fingerprint metafield format exactly:
    //   brand(ess|rev)|sorted MODULE:qty|ott:X|sides:Y
    const codes = Object.keys(state.modules).filter(c => state.modules[c] > 0).sort();
    if (!codes.length) return null;
    const moduleSig = codes.map(c => c + ':' + state.modules[c]).join(',');
    const brandCode = state.brand === 'reverie' ? 'rev' : 'ess';
    // Ottoman fingerprint: preserve `ott:<key>` when exactly one type with qty 1
    // (the only shape existing native bundles use); any multi-type or qty>1 build
    // gets a distinct `ott:<sorted-key:qty>+...` that intentionally matches no bundle.
    const ottEntries = Object.entries(state.ottomans || {}).filter(([_, q]) => q > 0);
    const ottSig = ottEntries.length === 0
      ? 'none'
      : (ottEntries.length === 1 && ottEntries[0][1] === 1
          ? ottEntries[0][0]
          : ottEntries.slice().sort(([a],[b]) => a.localeCompare(b)).map(([k,q]) => `${k}:${q}`).join('+'));
    const fp = `${brandCode}|${moduleSig}|ott:${ottSig}|sides:${state.sides}`;
    const matches = FIN_BY_FP[fp];
    if (!matches || matches.length !== 1) return null;
    const bundle = matches[0];
    const design = capitalize(state.design);
    const material = MATERIAL_LABEL(state.fabric, state.colour);
    const variant = bundle.variants.find(x => x.design === design && x.material === material && x.available);
    return variant ? { bundle, variant } : null;
  }

  // ---------- Finished-sofa preview ----------
  function updateFinishedSofa() {
    if (typeof window.byoSetFinishedSofa !== 'function') return;
    const m = matchBundleVariant();
    window.byoSetFinishedSofa(m ? m.variant.image : null, m ? m.variant.name : null, m ? m.bundle.title : null);
  }

  // ---------- Add to cart ----------
  async function addToCart() {
    // Filter out preview-only items without a Shopify variant id (e.g. smart features).
    const items = buildCart().items.filter(it => it.id != null).map(it => ({ id: it.id, quantity: it.qty }));
    if (!items.length) return;
    const btn = root.querySelector('[data-add]');
    btn.disabled = true; btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const err = await res.text();
        throw new Error(`Cart add failed: ${res.status} ${err}`);
      }
      sessionStorage.removeItem(STATE_KEY);
      window.location.href = '/cart';
    } catch (e) {
      console.error('[BYO]', e);
      btn.disabled = false; btn.textContent = 'Add to cart';
      alert('Sorry, we couldn’t add to cart. Please try again.');
    }
  }

  // ---------- Utils ----------
  function capitalize(s) { return s ? s[0].toUpperCase() + s.slice(1) : ''; }
  function formatMoney(cents) {
    // Shopify variant.price is in cents (integer)
    const n = (cents || 0) / 100;
    return new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
  }

  // ---------- Init ----------
  // Keep the step-4 scroll arrows in sync with scroll position + viewport size.
  (function () {
    const sc = root.querySelector('[data-modules]');
    if (sc) sc.addEventListener('scroll', updateModulesNav, { passive: true });
    window.addEventListener('resize', updateModulesNav);
  })();

  renderActiveStep();
})();
